function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import { IconButton } from 'swag-client-common/components/ui/icon-button';
import { getImageWithParams } from 'swag-client-common/utils/tricks';
import { ToolsPanel } from '../redesigned-tools-panel';
import { isImprintAreaChanged, isImageChanged, generateFontsImport, isVariantUpdated } from '../../../../../../redux/product/product.utils';
import { isMobile, isScreenWithBigResolution } from '../../../../../../utils/ui.utils';
import { MediaEditor } from './components/media-editor';
import InfoSize from './components/info-size';
import { InfoMessage } from './components/info-message';
import classes from './product-editor.scss';
export class ProductEditorComponent extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "prodImageRef", void 0);
    _defineProperty(this, "imprintAreaRef", void 0);
    _defineProperty(this, "notAdjustedForCurrentImage", true);
    this.onMouseEnterRect = this.onMouseEnterRect.bind(this);
    this.onMouseLeaveRect = this.onMouseLeaveRect.bind(this);
    this.positionRectContainer = this.positionRectContainer.bind(this);
    this.handleLogoInteract = this.handleLogoInteract.bind(this);
    this.handleLogoDeleted = this.handleLogoDeleted.bind(this);
    this.state = {
      showLogoControls: false,
      imprintAreaStyle: null,
      isLogoInteracted: false,
      isLogoDeleted: false
    };
  }
  componentDidMount() {
    const {
      fonts
    } = this.props;
    const css = generateFontsImport(fonts);
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
    window.addEventListener('resize', this.positionRectContainer);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.notAdjustedForCurrentImage = isImageChanged(nextProps.productImage, this.props.productImage);
    if (isVariantUpdated(nextProps.productImage, this.props.productImage)) {
      this.notAdjustedForCurrentImage = false;
    }
  }
  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (!nextState.imprintAreaStyle || !this.state.imprintAreaStyle) {
      return;
    }
    if (isImprintAreaChanged(nextState, this.state) && this.notAdjustedForCurrentImage) {
      this.notAdjustedForCurrentImage = false;
      this.props.onChangeImprintArea(nextState.imprintAreaStyle, this.state.imprintAreaStyle);
    }
  }
  componentDidUpdate(prevProps) {
    var _prevProps$productIma, _this$props$productIm;
    if (prevProps.isToolsPanelShown !== this.props.isToolsPanelShown || prevProps.isFullScreenMode !== this.props.isFullScreenMode || ((_prevProps$productIma = prevProps.productImage) === null || _prevProps$productIma === void 0 ? void 0 : _prevProps$productIma.embellishmentMethodId) !== ((_this$props$productIm = this.props.productImage) === null || _this$props$productIm === void 0 ? void 0 : _this$props$productIm.embellishmentMethodId)) {
      this.positionRectContainer();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.positionRectContainer);
  }
  onMouseEnterRect(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      showLogoControls: true
    });
  }
  onMouseLeaveRect(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      showLogoControls: false
    });
  }
  positionRectContainer() {
    const {
      productImage,
      view
    } = this.props;
    const rectangle = productImage && productImage.rectangle;
    if (rectangle) {
      const imprintAreaInPixels = {
        height: this.prodImageRef.height * rectangle.height / 100,
        width: this.prodImageRef.width * rectangle.width / 100,
        top: this.prodImageRef.offsetTop + this.prodImageRef.clientHeight * rectangle.top / 100,
        left: this.prodImageRef.offsetLeft + this.prodImageRef.clientWidth * rectangle.left / 100
      };
      this.setState({
        imprintAreaStyle: imprintAreaInPixels,
        view
      });
    }
  }
  handleLogoInteract(isLogoInteracted) {
    this.setState({
      isLogoInteracted
    });
  }
  handleLogoDeleted(isLogoDeleted) {
    this.setState({
      isLogoDeleted
    });
  }
  render() {
    const {
      productImage,
      isToolsPanelExists,
      logoSize,
      media,
      onZoomClick,
      isFullScreenMode,
      onProductImageClick,
      view,
      isSamplePromo,
      isLoggedIn,
      shouldShowImprintArea,
      isEditingSharedItem,
      isLimitedEdition,
      isLogoControlsDisabled
    } = this.props;
    const url = productImage === null || productImage === void 0 ? void 0 : productImage.url;
    const isImageWithImprintArea = productImage === null || productImage === void 0 ? void 0 : productImage.isImageWithImprintArea;
    const {
      imprintAreaStyle,
      resetImageToAuto,
      isLogoInteracted,
      showLogoControls
    } = this.state;
    const imprintAreaHasDimensions = imprintAreaStyle && !!imprintAreaStyle.height && !!imprintAreaStyle.width;
    const imageStyle = resetImageToAuto ? {
      maxWidth: 'none',
      maxHeight: 'none'
    } : {};
    const imageSrc = isScreenWithBigResolution() && url || getImageWithParams({
      url,
      height: !isMobile() && 750 || 350
    });
    const isMediaExist = media && !!media.length;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.fullZoomImageWrapper]: isFullScreenMode
      }, classes.toolsPanelShown, classes.wrapper)
    }, /*#__PURE__*/React.createElement(InfoMessage, {
      isEditingSharedItem: isEditingSharedItem,
      logos: media,
      view: view,
      isLogoDeleted: this.state.isLogoDeleted,
      isLogoInteracted: isLogoInteracted,
      isSamplePromo: isSamplePromo,
      isLimitedEdition: isLimitedEdition,
      className: classes.infoMessage
    }), logoSize && /*#__PURE__*/React.createElement(InfoSize, {
      className: classes.infoSize,
      logoSize: logoSize
    }), isToolsPanelExists && /*#__PURE__*/React.createElement(ToolsPanel, {
      isLoggedIn: isLoggedIn,
      className: classnames(classes.toolsPanel, {
        [classes.isFixed]: isFullScreenMode
      })
    }), /*#__PURE__*/React.createElement(IconButton, {
      onClick: onZoomClick,
      tooltipDirection: "left",
      dataTooltip: isFullScreenMode ? 'Zoom Out' : 'Zoom in',
      iconClassName: classnames({
        [classes.zoomIn]: !isFullScreenMode,
        [classes.zoomOut]: isFullScreenMode
      }),
      buttonClassName: classnames(classes.zoomButton, {
        [classes.zoomButtonInFullscreenMode]: isFullScreenMode
      }),
      ariaLabel: isFullScreenMode ? 'Zoom Out' : 'Zoom in'
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative',
        margin: '0 auto',
        height: '100%'
      }
    }, shouldShowImprintArea && isImageWithImprintArea && imprintAreaHasDimensions && /*#__PURE__*/React.createElement("div", _extends({
      className: classnames(classes.rect, {
        [classes.hiddenBorder]: isLogoControlsDisabled
      }),
      style: imprintAreaStyle,
      ref: imprintAreaRef => {
        this.imprintAreaRef = imprintAreaRef;
      }
    }, !isLogoControlsDisabled && {
      onMouseEnter: this.onMouseEnterRect,
      onMouseLeave: this.onMouseLeaveRect
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.cVerticalLine
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.cHorizontalLine
    }), isMediaExist && media.map(({
      mediaId,
      type
    }, index) => /*#__PURE__*/React.createElement(MediaEditor, _extends({
      productImage: productImage,
      mediaId: mediaId,
      key: mediaId,
      type: type,
      layer: index,
      logoAreaStyle: imprintAreaStyle,
      isFullScreenMode: isFullScreenMode,
      imprintAreaRef: this.imprintAreaRef,
      handleLogoDeleted: this.handleLogoDeleted
    }, !isLogoControlsDisabled && {
      showLogoControls: showLogoControls,
      onMouseEnterRect: this.onMouseEnterRect,
      onMouseLeaveRect: this.onMouseLeaveRect,
      onLogoInteract: this.handleLogoInteract
    })))), /*#__PURE__*/React.createElement(Image, {
      src: imageSrc,
      wrapperClassName: classnames({
        [classes.noImprintAreaImageWrapper]: !isImageWithImprintArea,
        [classes.noHeightFitting]: isFullScreenMode
      }, classes.imageWrapper),
      alt: "Product editor image",
      className: classes.image,
      imageStyle: imageStyle,
      style: {
        background: '#fff'
      },
      onClick: onProductImageClick,
      onLoad: this.positionRectContainer,
      getRef: el => {
        this.prodImageRef = el;
      }
    })));
  }
}